import { AddUserAccountDto } from '../../../../../../types';

interface Props {
  formData: AddUserAccountDto;
  setFormData: any;
  validating: boolean;
}
function UserBCFields({ formData, setFormData, validating }: Props) {
  return (
    <div id='bc_fields'>
      <div className='row'>
        {' '}
        <div className='col-md-3'>
          <div className='mb-3'>
            <label
              htmlFor='bc_username'
              className='globalInputLabel'
            >
              BC Username <span className='text-danger'>*</span>
            </label>
            <input
              type='text'
              className={`form-control   ubbe-input ${
                formData.bc_username ? 'highlighted-border' : ''
              }`}
              id='bc_username'
              placeholder='BC Username'
              autoComplete='new-password'
              maxLength={30}
              value={formData.bc_username}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  bc_username: e.target.value,
                });
              }}
            />
            {validating && formData.bc_username === '' && (
              <div className='error_text'>{'Please provide a valid name.'}</div>
            )}
          </div>
        </div>
        <div className='col-md-3'>
          <div className='mb-3'>
            <label
              htmlFor='location_code'
              className='globalInputLabel'
            >
              Location Code <span className='text-danger'>*</span>
            </label>
            <select
              className={`form-control form-select  ubbe-input ${
                formData.bc_location_code ? 'highlighted-border' : ''
              }`}
              id='location_code'
              aria-label='Location Code'
              value={formData.bc_location_code}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  bc_location_code: e.target.value,
                });
              }}
            >
              <option
                value='YEGFF'
                selected
              >
                YEGFF - Edmonton Freight Forwarding
              </option>
              <option value='YEG'>YEG - Edmonton</option>
              <option value='YEGFFAPP'>YEGFFAPP - Edmonton FF ubbe</option>
              <option value='ISUYEG'>ISUYEG - IShop4U - YEG</option>
              <option value='YEV'>131 - Inuvik</option>
            </select>
            <div
              className='invalid-feedback'
              id='location_code_error'
            >
              Please provide a valid Location Code.
            </div>
          </div>
        </div>
        <div className='col-md-6'></div>
      </div>
      <div className='row'>
        <div className='col-md-3'>
          <div className='mb-3'>
            <label
              htmlFor='cost_centre'
              className='globalInputLabel'
            >
              Cost Centre <span className='text-danger'>*</span>
            </label>
            <select
              className={`form-control form-select  ubbe-input ${
                formData.bc_cost_center ? 'highlighted-border' : ''
              }`}
              id='cost_centre'
              aria-label='Cost Centre'
              value={formData.bc_cost_center}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  bc_cost_center: e.target.value,
                });
              }}
            >
              <option
                value='210'
                selected
              >
                210 - Freight Forwarding
              </option>
              <option value='211'>211 - Supply Chain</option>
              <option value='213'>213 - Procurement of Goods</option>
              <option value='224'>224 - Distribution Services</option>
              <option value='224'>230 - Cargo Handling</option>
            </select>
          </div>
        </div>
        <div className='col-md-3'>
          <div className='mb-3'>
            <label
              htmlFor='branch_code'
              className='globalInputLabel'
            >
              Branch Code <span className='text-danger'>*</span>
            </label>
            <select
              className={`form-control form-select  ubbe-input ${
                formData.bc_branch_code ? 'highlighted-border' : ''
              }`}
              id='branch_code'
              aria-label='Branch Code'
              value={formData.bc_branch_code}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  bc_branch_code: e.target.value,
                });
              }}
            >
              <option
                value='130'
                selected
              >
                130 - Freight Forwarding
              </option>
              <option value='110'>110 - Inuvik</option>
              <option value='125'>125 - Edmonton</option>
              <option value='127'>127 - Ishop4u</option>
              <option value='131'>131 - ubbe</option>
              <option value='195'>195 - Projects</option>
            </select>
          </div>
        </div>
        <div className='col-md-6'></div>
      </div>
    </div>
  );
}

export default UserBCFields;
